<template>
    <div class="intelligence_container">
      <div class="intel_part01">
        <div>
          <p><span>触</span>不可及</p>
          <p>整合世界500强管理管理机制和最佳实践、执行标准与数据分析</p>
          <button @click="showIntelligentDialog = true">立即试用</button>
        </div>
      </div>
      <div class="intel_part02">
        <div>
          <img class="intel_image01" src="../assets/images/product01.png" alt="">
          <div>
            <h1>企业的销售痛点（客户资源管理）</h1>
            <ul>
              <li>销售把开发出来的客户资源作为自己的资产，所以销售离职以后，就把客户资源带走了</li>
              <li>销售业绩不理想，用了很多方法，但是销售业绩提升还是乏力</li>
              <li>销售团队跑客户的频率和效率无法跟踪和衡量，大量客户资源沉淀无产出</li>
              <li>企业对于客户数据管理没有体系，客户数据抓取困难，无法帮助业务作出决策</li>
              <li>执行标准与数据分析等要素，以精细化运营为目标，实现企业即视化决策，塑造全要素销售能力、并打造卓越绩效销售团队的管理目标。</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part11">
        <div>
          <img src="../assets/images/product02.png" alt="">
          <div>
            <h1>企业的销售痛点（绩效考核）</h1>
            <ul>
              <li>销售团队缺乏系统性管理机制，销售业绩的管理侧重于单点 内容，只能头疼医头，脚疼医脚</li>
              <li>企业没有持续而有规律的管理节奏，销售团队处于无序化，野蛮生长的状态</li>
              <li>销售管理的各项内容没有标准化，对于销售人员的考核比较 单一，缺乏综合评估的手段</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part04">
        <div>
          <img class="intel_image02" src="../assets/images/product03.png" alt="">
          <div class="intel_opportunity">
            <h1>企业的销售痛点（商机管理）</h1>
            <ul>
              <li>销售忙于项目的招投标，但是赢率很低，只能杀价和陪标</li>
              <li>企业对于销售目前在跟进的机会不了解，没有一个全局的景观，销售业绩是否能完成没有底气</li>
              <li>企业对于完成销售目标需要寻找和开发多少项目机会没有概念，是否能完成目标全靠运气，销售管理处于失控状态</li>
              <li>企业缺乏商机管理体系，销售业绩忽高忽低，年底冲刺变成常态，带来很多不确定性</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part12">
        <div>
          <img src="../assets/images/product04.png" alt="">
          <div>
            <h1>企业的销售痛点（销售预测）</h1>
            <ul>
              <li>销售预测不准，随意性强</li>
              <li>由于销售预测不准，企业的供应链经常没有备货，导致交货期长，市场竞争力下降</li>
              <li>销售预测准确性不高，没有好的方法改进预测准确率</li>
              <li>销售团队没把预测当回事，经常不兑现承诺</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part05">
        <div>
          <img class="intel_image03" src="../assets/images/product05.png" alt="">
          <div class="intel_opportunity">
            <h1 class="intel_forecast_title">企业的销售痛点（预测）</h1>
            <ul>
              <li>销售业绩的管理没有体系，销售业绩不可控</li>
              <li>销售的承诺目标不能兑现，执行力较弱</li>
              <li>企业没有定期启动销售流程的机制，销售业绩不可控</li>
              <li>企业的销售预测不准确是常态，缺乏有效的改善手段</li>
              <li>销售团队的大部分业绩靠年底冲刺，为企业整体运营的成本 管控带来很高的风险</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part13">
        <div>
          <img src="../assets/images/product06.png" alt="">
          <div class="intel_sale">
            <h1>企业的销售痛点（销售MBR）</h1>
            <ul>
              <li>企业没有跟进销售业绩的机制，不了解当前销售业绩的进度，业绩管理处于失控状态</li>
              <li>销售业绩和管理机制没有定期复盘，即使通过年底冲刺，也离目标很远</li>
              <li>企业没有流程去引导销售团队制定计划来改善销售业绩</li>
              <li>企业对于可能发生的业绩风险，没有意识，也没有预警系统</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part06">
        <div>
          <img src="../assets/images/product07.png" alt="">
          <div class="intel_opportunity">
            <h1 class="intel_forecast_title">企业的销售痛点（目标分配）</h1>
            <ul>
              <li>企业制定销售目标时缺乏方法论，定目标靠拍脑袋，目标定出来不靠谱</li>
              <li>销售目标分配搞一刀切，团队成员间的业绩差异大，销售人员离职率高</li>
              <li>销售目标分配不下去，销售团队对于自己的目标不明确</li>
              <li>销售团队认为销售目标定得不靠谱，意见多多，所以推行目标激励机制困难</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part07">
        <div>
          <img class="intel_budget_image" src="../assets/images/product08.png" alt="">
          <div class="intel_sale">
            <h1>企业的销售痛点（预算）</h1>
            <ul>
              <li>企业在没有考虑自身资源的前提下盲目扩大业绩导致企业出现危机</li>
              <li>企业经常发现到了年底一核算，销售目标没有做到，但是预算花超了，所以销售成本高出预算很多</li>
              <li>企业缺乏人均生产力概念和考核标准，团队随意增加人员，造成企业运营成本居高不下</li>
              <li>企业缺乏成本概念和考核标准，在计划和执行过程中都不能控制好成本，很容易造成亏损</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part08">
        <div>
          <img src="../assets/images/product09.png" alt="">
          <div class="intel_opportunity intel_coverage">
            <h1 class="intel_forecast_title">企业的销售痛点（销售覆盖率）</h1>
            <ul>
              <li>企业的销售覆盖策略不清晰，资源错配</li>
              <li>企业的销售方式单一，客户激活率低，销售线索挖掘乏力</li>
              <li>企业没有销售区域划分的概念，销售资源重复投入而造成浪费</li>
              <li>企业缺乏销售人均覆盖和人均生产力的概念，销售成本居高不下</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part03 intel_part09">
        <div>
          <img class="intel_budget_image" src="../assets/images/product10.png" alt="">
          <div class="intel_sale">
            <h1>企业的销售痛点（客户分类）</h1>
            <ul>
              <li>企业忙于打单子，什么类型和地区的客户都做，但是真正留存下来复购的客户很少，每次都要开发新客户，销售时间成本和费用成本都很高</li>
              <li>由于企业的客户类型繁多，产品定制化要求高，产品标准化程度低导致毛利率持续下降</li>
              <li>由于企业对于客户定义不清晰，没有适合的销售模型，销售业绩提升缓慢</li>
              <li>由于企业没有销售区域和行业划分的概念，销售经常互相抢客户，销售资源浪费，成功案例难以复制</li>
              <li>企业没有清晰的客户清单，销售团队开发市场漫无目标，销售线索获取困难，成交率低</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="intel_part02 intel_part10">
        <div>
          <img src="../assets/images/product11.png" alt="">
          <div class="intel_opportunity">
            <h1 class="intel_forecast_title">企业的销售痛点（销售阶段）</h1>
            <ul>
              <li>销售对于线索和机会的差别不清晰，造成销售效率下降，做无用功</li>
              <li>销售对于项目进度的把控缺乏清晰的标准，管理者和销售由于经历和经验不同，经常对于项目的预期出现分歧，沟通困难</li>
              <li>销售团队缺乏销售阶段的概念，对于各个阶段应该完成的工作内容不清晰</li>
              <li>企业经常出现销售明星绑架公司的情况，销售人才培养困难</li>
            </ul>
          </div>
        </div>
      </div>
      <my-dialog :show-dialog.sync="showIntelligentDialog"></my-dialog>
    </div>
</template>

<script>
    import myDialog from '../components/my-dialog'
    export default {
        name: 'intelligentCRM',
        data:function(){
          return {
            showIntelligentDialog:false
          }
        },
        components:{myDialog}
    }
</script>



// WEBPACK FOOTER //
// src/components/intelligentCRM.vue